<p-dialog id="ConfirmDelete"
          [header]="header"
          [appTabTitle]="header"
          [(visible)]="display"
          [modal]="modal"
          [resizable]="false"
          (onShow)="onShowDialog()"
          (onHide)="onHideDialog()"
          [style]="{width: '30vw', height: '50hw'}">

  <ng-template pTemplate="content">
    <div class="grid">
      <div class="col-12 mt-2">
        <h5>{{messageText}}</h5>
        <ng-content></ng-content>
      </div>

        <div class="col-12 mt-6" *ngIf="typeConfirmation">
          <span class="p-float-label">
            <input id="smtng-input" type="text" (keyup.enter)="doConfirm($event)" pInputText [(ngModel)]="deleteConfirmStr" style="width:100%">
            <label for="float-input">Напечатайте "{{confirmText}}" для подтверждения...</label>
          </span>
        </div>
      </div>
</ng-template>
  <ng-template pTemplate="footer">
    <p-button label="ОК!" (click)="onConfirm('ok')" [disabled]="!canConfirm"></p-button>
    <p-button label="Отмена" (click)="display=false"></p-button>
  </ng-template>
</p-dialog>
